/* eslint-disable */
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { shipmentListUrlSortField } from "@saleor/shipment/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  ProducttagsListPath,
  ProducttagsListUrlQueryParams,
  producttagPath,
  productTageQueryParams,
  ProducttagsAddPath
} from "./urls";

import ProducttagsListComponent from "./views/ProducttagsList";
import ProductTagsDetailsComponent from "./views/ProductTagsDetails";
import { saleDetailsPageTab } from "./components/ProductTagsDetailsPage/ProductTagsDetailsPage";
import ProductTagsCreate from "./views/ProductTagsCreate";
// import ProducttagsListComponent from "./views/ProducttagsListPaper";

const ProducttagsList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: ProducttagsListUrlQueryParams = asSortParams(
    qs,
    shipmentListUrlSortField
  );
  return <ProducttagsListComponent params={params} />;
};
const SaleDetailsView: React.FC<RouteComponentProps<{ id: string }>> = ({
  match,
  location
}) => {
  const { activeTab, ...qs } = parseQs(location.search.substr(1));
  const params: productTageQueryParams = {
    ...qs,
    activeTab: saleDetailsPageTab(activeTab)
  };
  return (
    <ProductTagsDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const ProducttagSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.producttags)} />
      <Switch>
        <Route exact path={ProducttagsListPath} component={ProducttagsList} />
        <Route exact path={ProducttagsAddPath} component={ProductTagsCreate} />
        <Route path={producttagPath(":id")} component={SaleDetailsView} />
      </Switch>
    </>
  );
};

export default ProducttagSection;
